'use strict';

angular.module('atex.dam').directive('damInterestingTerms', function(DamSearchService, DamFoldersService) {
  return {
    restrict : 'ACE',

    templateUrl : 'views/dam-interestingterms.html',

    replace : true,

    scope : {
      entries : "="
    },

    link: function(scope, element, attrs) {
      scope.$watch('entries', function(entries, oldEntries) {
        if (entries !== oldEntries && entries.length > 0) {
          element.html("<div class='form-group'><select class='form-control' multiple ></select></div>");

          var obj = element.find('.form-control');
          obj.select2();

          var tags = [];

          angular.forEach(entries, function(entry, key) {
            if (entry !== null) {
              tags.push({
                id : entry,
                text : entry
              });
            }
          });

          obj.select2('data', tags);
          obj.select2('disable', true);

          angular.forEach(entries, function(entry, key) {
            var obj = element.find('.select2-search-choice').find('div').filter(function() {
              return $(this).text() === entry;
            });

            obj.parent().addClass('pointer');
            obj.click(function() {
              $(this).parent().addClass('selected_clr');
              if (DamFoldersService.listingFolder && $('#searchvalueinput').val()) {
                DamFoldersService.executeQuery(DamFoldersService.listingFolder, entry);
              } else {
                DamSearchService.simpleSearch(entry);
              }
            });
          });
        }
      }, true);
    }
  };
});
